<template>
  <div class="uploadContent">
    <el-upload
        :show-file-list="showFileList"
        :auth-index="authIndex"
        action=""
        :multiple="multiple"
        :http-request="getVoucher"
        :file-list="fileList"
        :btn-name="btnName"
        :on-change="handleChange"
        :on-preview="filePreview"
        :file-type="fileType"
    >
      <el-button size="mini" type="primary">{{btnName}}</el-button>
    </el-upload>
    <el-progress v-if="showProgress" class="progress" :percentage="percentage"/>
  </div>
</template>

<script>
  import axios from "axios";
  export default {
    props: {
      // 批量上传
      multiple: {
        type: Boolean,
        default: false,
      },
      // 模块权限
      authIndex: {
        type: Number,
        required: true,
      },
      // 是否显示已上传文件列表
      showFileList: {
        type: Boolean,
        default: false,
      },
      btnName: {
        type: String,
        default: "上传文件",
      },
      // 文件类型  默认所有类型
      fileType: {
        type: Array,
        default: () => {
          return [];
        },
      },
    },

    data() {
      return {
        fileList: [],
        // 上传进度
        percentage: 0,
        showProgress: false,
      };
    },

    methods: {
      // 获取文件上传的url
      getVoucher(file) {
        if (this.fileType.length) {
          let fileType = file.file.name.split(".")[1];
          if (!this.fileType.includes(fileType)) {
            this.$confirm(`请上传 ${this.fileType.join()} 文件`, "错误", {
              type: "error",
              showCancelButton: false,
            });
            return;
          }
        }
        this.showProgress = true;
        this.$http.get("basic", `files/getUploadUrl?filename=${file.file.name}&authIndex=${this.authIndex}`).then((res) => {
          if (res.success) {
            axios({
              method: "PUT",
              headers: res.data.headers,
              url: res.data.url,
              data: file.file,
              onUploadProgress: (progressEvent) => {
                this.percentage = Number(((progressEvent.loaded / progressEvent.total) * 100).toFixed(0));
              },
            }).then(() => {
              this.fileList.forEach((item) => {
                if (item.name == file.file.name) {
                  item.key = res.data.key;
                }
              });
              if (this.percentage === 100) {
                this.$emit("upload-success", this.fileList);
                this.showProgress = false;
              }
            });
          }
        });
      },

      // 文件预览
      filePreview(file) {
        this.$http.get("basic", `files/getDownloadUrl?key=${file.key}`).then((res) => {
          if (res.success) {
            window.open(res.data);
          }
        });
      },

      // 文件列表
      handleChange(file, fileList) {
        if (fileList.length > 1) {
          fileList.splice(0, 1);
        }
        this.fileList = fileList;
      },
    },
  };
</script>

<style scoped>
.uploadContent {
  margin-bottom: 5px;
  display: flex;
  margin-right: 10px;
}
.progress {
  flex: 1;
  line-height: 28px;
  margin-left: 5px;
}
</style>
